<template>

    <div class="uk-container-large uk-margin-auto uk-margin-top   uk-padding-small">

        <div class="cart-content-wrapper uk-flex uk-flex-between">
            <div class="cart-content uk-width-expand uk-margin-right">
                <div class="uk-card uk-card-default">
                    <div class="uk-card-hat uk-margin-remove-bottom uk-background-secondary uk-text-inverse-color uk-flex uk-flex-between uk-flex-middle">
                        <span class=" uk-text-inverse-color uk-margin-remove">{{title}}</span>

                    </div>

                    <div class="uk-card-body">

                        <div class="cart extended" >
                            <div v-if="isEmpty" class="cart-empty uk-padding uk-flex uk-flex-column">
                                <h3 class="cart-empty-text">Your cart is empty. Now might be a good time to add something!</h3>
                                <form-button type="primary">SHOP NOW</form-button>
                            </div>


                            <div v-if=" ! isEmpty" class="cart-main">
                                <div v-if="summaryPosition == 'top' || summaryPosition == 'both'"
                                     class="cart-header-summery uk-panel uk-background-muted uk-padding-small  uk-text-center">
                                    <div class="uk-flex uk-flex-between">
                                        <div class="header-item-count ">
                                            <span class="uk-margin-small-right">Total {{itemCount}} items:</span>
                                        </div>
                                        <div class="header-prices uk-text-right" >
                                            <div class="fixed  ">
                                                <div class="cart-header-final-price">
                                                    <inline-block>2 525 F</inline-block>
                                                    <inline-block class="cart-header-spacer" style="width: 34px"></inline-block>
                                                </div>
                                            </div>
                                            <div class="recurring">
                                                <div class="cart-header-final-price">
                                                    <inline-block>+ 525 F</inline-block>
                                                    <inline-block class="uk-text-small" style="width: 34px;">/ MO</inline-block>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div class="cart-content uk-padding-small uk-padding-remove-vertical ">
                                    <div class="uk-margin-bottom" v-if="showTaxInfo">
                                        <span>*All prices below include VAT. For details, see Summary </span>
                                    </div>
                                    <div class="uk-flex-uk-flex-column  uk-width-expand uk-margin-bottom ">
                                        <!-- regular product demo -->
                                        <div class="entry">
                                            <div class="entry-inner uk-flex uk-flex-stretch">
                                                <div class="entry-image uk-width-small uk-background-cover uk-margin-right"
                                                     :style="`background-image: url('images/products/airpods.jpg')`">

                                                </div>
                                                <div class="entry-details uk-width-3-6 uk-margin-right">
                                                    <div class="details-wrap">
                                                        <div class="entry-title">Some Product</div>
                                                        <div class="entry-detail uk-margin-small-bottom">
                                                            <span class="entry-qty-label">Quantity: </span><span class="entry-qty-number">2</span>
                                                            <br>
                                                            <span>Short product description</span>
                                                        </div>
                                                        <form-button
                                                                v-if="mode == 'currentCart'"
                                                                class="line-edit-button"
                                                                size="small"
                                                                icon="close"
                                                                type="muted">Remove</form-button>
                                                    </div>
                                                </div>
                                                <div class="entry-price uk-flex uk-flex-column" v-if="showPricePerEntry">
                                                    <div class="entry-final-price" >750 F</div>
                                                    <div class="entry-old-price uk-text-small"
                                                         style="text-decoration: line-through">900 F</div>
                                                </div>


                                            </div>

                                            <hr class="uk-hr">
                                        </div>



                                        <!-- regular sub demo -->
                                        <div class="entry" v-if="extended">
                                            <div class="entry-inner entry-builder entry-builder--subscription uk-flex uk-flex-stretch">
                                                <div class="plan-block uk-width-1-2 uk-flex uk-flex-stretch uk-overflow-hidden">

                                                    <div class="uk-flex uk-flex-stretch">
                                                        <div class="entry-image uk-width-small uk-background-cover "
                                                             :style="`background-image: url('images/nice.jpg')`">

                                                        </div>
                                                        <div class="entry-details uk-flex uk-flex-stretch uk-width-expand uk-margin-right uk-padding-small">
                                                            <div class="details-wrap uk-flex uk-flex-column">
                                                                <div class="entry-title">20Go Plan + Device</div>
                                                                <div class="entry-detail">
                                                                    <span class="commitment-qty-label">commitment: </span><span class="entry-qty-number">12 MO</span>
                                                                    <br>
                                                                    <span>20Go 4G data,<br>Phone Number: 89 213 828</span>
                                                                </div>

                                                                <div class="subscription-builder-part-footer">
                                                                    <div class="builder-piece-price uk-margin-small-bottom">
                                                                        <div class="initial-price">
                                                                            <span class="first-price">500 F /MO</span><br>
                                                                            <span>for 12 months, then <span class="later-price-actual-price">625 F/ MO</span></span>
                                                                        </div>
                                                                    </div>
                                                                    <button-group v-if="mode == 'currentCart'">
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="close"
                                                                                type="muted">Remove</form-button>
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="pencil"
                                                                                type="muted">Edit</form-button>
                                                                    </button-group>
                                                                </div>



                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="plus uk-text-inverse-color uk-background-secondary"><div uk-icon="plus" class=""></div></div>

                                                <div class="phone-block uk-width-1-2 uk-flex uk-flex-stretch uk-overflow-hidden">

                                                    <div class="uk-flex uk-flex-stretch ">
                                                        <div class="entry-image uk-width-small uk-background-cover "
                                                             :style="`background-image: url('images/products/phone_cart.jpg')`">

                                                        </div>
                                                        <div class="entry-details uk-flex uk-flex-stretch uk-width-expand uk-margin-right uk-padding-small">
                                                            <div class="details-wrap uk-flex uk-flex-column">
                                                                <div class="entry-title">iPhone 12 PRO</div>
                                                                <div class="entry-detail">
                                                                    <span>128GB memory,<br>matte black</span>
                                                                </div>
                                                                <div class="subscription-builder-part-footer">
                                                                    <div class="builder-piece-price uk-margin-small-bottom">
                                                                        <div class="initial-price">
                                                                            <span class="first-price">4 000 F</span><br>
                                                                            <span>+ <span class="later-price-actual-price">225 F/ MO </span><span>facilitated payment</span></span>
                                                                        </div>
                                                                    </div>
                                                                    <button-group v-if="mode == 'currentCart'">
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="close"
                                                                                type="muted">Remove</form-button>
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="pencil"
                                                                                type="muted">Edit</form-button>
                                                                    </button-group>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                            <hr class="uk-hr" v-if="extended">
                                        </div>

                                        <!-- sub no phone -->
                                        <div class="entry" v-if="extended">
                                            <div class="entry-inner entry-builder entry-builder--subscription uk-flex uk-flex-stretch">
                                                <div class="plan-block uk-width-1-2 uk-flex uk-flex-stretch uk-overflow-hidden">

                                                    <div class="uk-flex uk-flex-stretch">
                                                        <div class="entry-image uk-width-small uk-background-cover "
                                                             :style="`background-image: url('images/nice.jpg')`">

                                                        </div>
                                                        <div class="entry-details uk-flex uk-flex-stretch uk-width-expand uk-margin-right uk-padding-small">
                                                            <div class="details-wrap uk-flex uk-flex-column">
                                                                <div class="entry-title">20Go Plan + Device</div>
                                                                <div class="entry-detail">
                                                                    <span class="commitment-qty-label">commitment: </span><span class="entry-qty-number">12 MO</span>
                                                                    <br>
                                                                    <span>20Go 4G data,<br>Phone Number: 89 213 828</span>
                                                                </div>

                                                                <div class="subscription-builder-part-footer">
                                                                    <div class="builder-piece-price uk-margin-small-bottom">
                                                                        <div class="initial-price">
                                                                            <span class="first-price">500 F /MO</span><br>
                                                                            <span>for 12 months, then <span class="later-price-actual-price">625 F/ MO</span></span>
                                                                        </div>
                                                                    </div>
                                                                    <button-group v-if="mode == 'currentCart'">
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="close"
                                                                                type="muted">Remove</form-button>
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="pencil"
                                                                                type="muted">Edit</form-button>
                                                                    </button-group>
                                                                </div>



                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="plus uk-text-inverse-color uk-background-secondary"><div uk-icon="plus" class=""></div></div>

                                                <div class="phone-block phone-cta uk-width-1-2 uk-flex uk-flex-stretch uk-overflow-hidden">


                                                        <div class="entry-details uk-width-1-1  uk-height-1-1 uk-flex-uk-flex-center "
                                                        @click="$router.push({name: 'builder-demo'})">

                                                            <div class="add-mobile-cta uk-width-1-1 uk-height-1-1 uk-flex uk-flex-column uk-flex-center uk-flex-middle"
                                                                 v-if="mode == 'currentCart'">
                                                                <div class="uk-width-1-1 uk-flex uk-flex-center uk-flex-middle" uk-icon="icon:plus; ratio: 5"></div>
                                                                <div class="cta-text uk-flex uk-flex-center  uk-flex-column uk-flex-middle uk-width-1-1">
                                                                    <h3 class="cta-text-title uk-text-center uk-margin-remove-bottom">Choose a device for your plan!</h3><br>
                                                                    <span class="uk-text-small">Demo: will use smarphone icon instead of +</span>
                                                                </div>
                                                            </div>

                                                            <div class="add-mobile-cta disabled uk-width-1-1 uk-height-1-1 uk-flex uk-flex-column uk-flex-center uk-flex-middle"
                                                                 v-if="mode == 'pastCart'">
                                                                <div class="uk-width-1-1 uk-flex uk-flex-center uk-flex-middle" uk-icon="icon:close; ratio: 3"></div>
                                                                <div class="cta-text uk-flex uk-flex-center  uk-flex-column uk-flex-middle uk-width-1-1">
                                                                    <h3 class="cta-text-title uk-text-center uk-margin-remove-bottom">Without a device</h3><br>
                                                                </div>
                                                            </div>

                                                        </div>

                                                </div>


                                            </div>
                                            <hr class="uk-hr" v-if="extended">
                                        </div>

                                        <!-- phone no sub -->
                                        <div class="entry" v-if="extended">
                                            <div class="entry-inner entry-builder entry-builder--subscription uk-flex uk-flex-stretch">
                                                <div class="plan-block uk-width-1-2 uk-flex uk-flex-stretch uk-overflow-hidden">

                                                    <div class="entry-details uk-width-1-1  uk-height-1-1 uk-flex-uk-flex-center "
                                                         @click="$router.push({name: 'builder-demo'})">

                                                        <div class="add-subscription-cta uk-width-1-1 uk-height-1-1 uk-flex uk-flex-column uk-flex-center uk-flex-middle"
                                                             v-if="mode == 'currentCart'">
                                                            <div class="uk-width-1-1 uk-flex uk-flex-center uk-flex-middle" uk-icon="icon:plus; ratio: 5"></div>
                                                            <div class="cta-text uk-flex uk-flex-center  uk-flex-column uk-flex-middle uk-width-1-1">
                                                                <h3 class="cta-text-title uk-text-center uk-margin-remove-bottom">Choose your plan!</h3><br>
                                                                <span class="uk-text-small">Demo: will use simcard icon instead of +</span>
                                                            </div>
                                                        </div>

                                                        <div class="add-subscription-cta disabled uk-width-1-1 uk-height-1-1 uk-flex uk-flex-column uk-flex-center uk-flex-middle"
                                                             v-if="mode == 'pastCart'">
                                                            <div class="uk-width-1-1 uk-flex uk-flex-center uk-flex-middle" uk-icon="icon:close; ratio: 3"></div>
                                                            <div class="cta-text uk-flex uk-flex-center  uk-flex-column uk-flex-middle uk-width-1-1">
                                                                <h3 class="cta-text-title uk-text-center uk-margin-remove-bottom">Without a plan</h3><br>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="plus uk-text-inverse-color uk-background-secondary"><div uk-icon="plus" class=""></div></div>

                                                <div class="phone-block uk-width-1-2 uk-flex uk-flex-stretch uk-overflow-hidden">

                                                    <div class="uk-flex uk-flex-stretch ">
                                                        <div class="entry-image uk-width-small uk-background-cover "
                                                             :style="`background-image: url('images/products/phone_cart.jpg')`">

                                                        </div>
                                                        <div class="entry-details uk-flex uk-flex-stretch uk-width-expand uk-margin-right uk-padding-small">
                                                            <div class="details-wrap uk-flex uk-flex-column">
                                                                <div class="entry-title">iPhone 12 PRO</div>
                                                                <div class="entry-detail">
                                                                    <span>128GB memory,<br>matte black</span>
                                                                </div>
                                                                <div class="subscription-builder-part-footer">
                                                                    <div class="builder-piece-price uk-margin-small-bottom">
                                                                        <div class="initial-price">
                                                                            <span class="first-price">5 525 F</span><br>
                                                                        </div>
                                                                    </div>
                                                                    <button-group v-if="mode == 'currentCart'">
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="close"
                                                                                type="muted">Remove</form-button>
                                                                        <form-button
                                                                                class="line-edit-button"
                                                                                size="small"
                                                                                icon="pencil"
                                                                                type="muted">Edit</form-button>
                                                                    </button-group>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="uk-margin-bottom" v-if="showTaxInfo">
                                        <span>*All prices below include VAT. For details, see Summary </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="price-summary uk-width-medium "
                 style="align-self: flex-start;"
                 >
                <div id="test"
                     class="type-summary-wrapper uk-card uk-card-default"
                     v-if="showPriceSummeryByType"
                     ref="priceSummarySticky">
                    <!-- this becomes sticky from script-->

                    <div class="uk-card-hat uk-margin-remove-bottom uk-background-secondary uk-text-inverse-color uk-flex uk-flex-between uk-flex-middle">
                        <span class=" uk-text-inverse-color uk-margin-remove">Summary</span>
                    </div>

                    <div class="type-price-summary uk-card-body uk-overflow-auto"

                         v-if="showPriceSummeryByType">


                        <div class="price-type-block uk-background-muted uk-padding-small uk-margin-bottom ">
                            <div class="type-summary uk-flex ">

                                <div class="desc-col uk-width-2-3 uk-margin-right"
                                     :class="{'active' : expandedImmediatePrice}">
                                    <div class="uk-flex uk-flex-middle"

                                         @click="toggleMonthlyPrice()">
                                        <span class="desc-icon" uk-icon="chevron-right"></span>
                                        <span class="type-summary-expand-text">{{mode == 'currentCart' ? 'Today' : 'On order'}}</span>

                                    </div>

                                </div>
                                <div class="price-col uk-width-1-3 uk-text-right">
                                    <span>12 700 F</span>
                                </div>

                            </div>
                            <div v-if="showTaxInfo">
                                16% VAT (643 F) included
                            </div>
                            <div v-if="showTaxInfo">
                                13% VAT (143 F) included
                            </div>

                            <div class="type-details uk-animation-slide-left-small" v-show="expandedImmediatePrice">
                                <hr class="uk-margin-top">
                                <div class="type-detail uk-flex">
                                    <div class="desc-col uk-width-2-3 uk-margin-right">
                                        <span>Some device</span>
                                    </div>
                                    <div class="price-col uk-width-1-3 uk-text-right">
                                        9 700 F
                                    </div>
                                </div>
                                <div class="uk-text-small uk-margin-small-bottom" v-if="showTaxInfo"><span>16% VAT (172 F) included</span></div>

                                <div class="type-detail uk-flex">
                                    <div class="desc-col uk-width-2-3 uk-margin-right">
                                        Another device
                                    </div>
                                    <div class="price-col uk-width-1-3 uk-text-right">
                                        5 700 F
                                    </div>
                                </div>
                                <div class="uk-text-small uk-margin-small-bottom" v-if="showTaxInfo"><span>16% VAT (72 F) included</span></div>

                                <div class="type-detail uk-flex">
                                    <div class="desc-col uk-width-2-3 uk-margin-right">
                                        Sim Card, 3pcs
                                    </div>
                                    <div class="price-col uk-width-1-3 uk-text-right">
                                        0 F
                                    </div>
                                </div>
                                <div class="uk-text-small uk-margin-small-bottom" v-if="showTaxInfo"><span>Not subject to tax</span></div>



                            </div>

                        </div>

                        <div class="price-type-block uk-background-muted  uk-padding-small ">
                            <div class="type-summary uk-flex ">

                                <div class="desc-col uk-width-2-3 uk-margin-right"
                                     :class="{'active' : expandedMonthlyPrice}">
                                    <div class="uk-flex uk-flex-middle"

                                         @click="toggleImmediatePrice()">
                                        <span class="desc-icon" uk-icon="chevron-right"></span>
                                        <span class="type-summary-expand-text">Per month</span>
                                    </div>
                                </div>
                                <div class="price-col uk-width-1-3 uk-text-right">
                                    1 075 F
                                </div>

                            </div>
                            <div v-if="showTaxInfo">
                                16% VAT (243 F) included
                            </div>
                            <div v-if="showTaxInfo">
                                13% VAT (43 F) included
                            </div>

                            <div class="type-details uk-animation-slide-left-small" v-show="expandedMonthlyPrice">
                                <hr class="uk-margin-top">
                                <div class="type-detail uk-flex">
                                    <div class="desc-col uk-width-2-3 uk-margin-right">
                                        10Go plan w/24 MO commitment
                                    </div>
                                    <div class="price-col uk-width-1-3 uk-text-right">
                                        800 F
                                    </div>
                                </div>
                                <div class="uk-text-small uk-margin-small-bottom" v-if="showTaxInfo"><span>13% VAT (92 F) included</span></div>

                                <div class="type-detail uk-flex uk-margin-small-top">
                                    <div class="desc-col uk-width-2-3 uk-margin-right">
                                        Device X facilitated payment
                                    </div>
                                    <div class="price-col uk-width-1-3 uk-text-right">
                                        200 F
                                    </div>
                                </div>
                                <div class="uk-text-small uk-margin-small-bottom" v-if="showTaxInfo"><span>13% VAT (32 F) included</span></div>

                                <div class="type-detail uk-flex uk-margin-small-top">
                                    <div class="desc-col uk-width-2-3 uk-margin-right">
                                        Something else
                                    </div>
                                    <div class="price-col uk-width-1-3 uk-text-right">
                                        75 F
                                    </div>
                                </div>
                                <div class="uk-text-small uk-margin-small-bottom" v-if="showTaxInfo"><span>13% VAT (4 F) included</span></div>



                            </div>


                        </div>

                        <div class="cta" v-if="mode == 'currentCart'">
                            <div class="uk-text-success uk-text-center uk-margin-top uk-text-semibold uk-flex uk-flex-middle uk-flex-center">
                                <icon-text icon="lock">Secure Payment</icon-text>
                            </div>
                            <form-button :full-width="true"
                                         icon-end="chevron-right"
                                         @click="$router.push({name: 'checkout'})"
                                         class="uk-margin-top">CHECKOUT</form-button>
                        </div>



                    </div>

                </div>
            </div>

        </div>



    </div>


</template>

<script>
    import {computed} from 'vue';
    import { useStore } from 'vuex'
    import asyncOperations  from '@/client/extensions/composition/asyncOperations.js';
    import ProductUpsaleCarousel from "@/client/components/ecommerce/products/ProductUpsaleCarousel.vue";

    export default {
        setup (props) {
            let {asyncOps, asyncOpsReady} = asyncOperations(props, useStore());

            return {asyncOps, asyncOpsReady}
        },
        props: {
            title: {
              type: String,
              default: 'Your Cart'
            },
            mode: {
                type: String,
                default: 'currentCart',
            },
            showTaxInfo: {
                type: Boolean,
                default: false
            },
            summaryPosition: {
                type: String,
                default: 'top'
            },
            extended: {
                type: Boolean,
                default: false
            },
            /**
             * Should the cart show pricing for each of its entries
             */
            showPricePerEntry : {
                type: Boolean,
                default: true
            },
            /**
             * Should the cart show price summery that is grouped based on type - recurring or one time
             */
            showPriceSummeryByType: {
                type: Boolean,
                default: false
            }
        },
        components: {
            ProductUpsaleCarousel,
        },

        data: function () {
            return {
                expandedImmediatePrice: false,
                expandedMonthlyPrice: false,
                productIds :    computed ( () => this.$store.getters['cart/productIds']),
                cartEntriesRaw : computed( () => this.$store.getters['cart/entries']),
                products: [],
                asyncData : {
                    // simple version: just route for the data
                    products: {
                        target: 'product',
                        data: computed ( () => {return {'ids' : this.productIds};}),
                        options : {
                            method: 'get'
                        }
                    }
                }
            };
        },
        computed: {
            finalCartEntries () {
                let raw = this.cartEntriesRaw;
                let final = [];

                raw.forEach((entry) => {
                    let product = this.getLocalProductById(entry.id),
                        priceBeforeDiscount = product.price * entry.qty,
                        price = priceBeforeDiscount,
                        discount = entry.discount,
                        discountType = entry.discountType,
                        images = product.images || [],
                        image  = images[0] || {},
                        imageUrl = image.url || '',
                        finalDiscount;

                    if (discount > 0 && discountType == 'flat') {
                        price = priceBeforeDiscount - discount;
                    }

                    if (discount > 0 && discountType == 'percent') {
                        price = Math.ceil(priceBeforeDiscount * (100 - discount) / 100);
                        console.log(entry, product, price);
                    }

                    finalDiscount = priceBeforeDiscount - price;

                    final.push( {
                        product,
                        price,
                        priceBeforeDiscount,
                        hasDiscount : finalDiscount > 0,
                        qty:entry.qty,
                        imageSrc : imageUrl
                    })
                });

                return final;
            },
            cartTotalBeforeDiscount () {
                let total = 0;

                this.finalCartEntries.forEach((entry) => {
                    total = total + entry.priceBeforeDiscount;
                });

                return total;
            },
            cartTotal () {
                let total = 0;

                this.finalCartEntries.forEach((entry) => {
                    total = total + entry.price;

                });

                return total;
            },
            isEmpty () {
               // return this.$store.getters['cart/itemCount'] < 1;
                return false
            },
            itemCount () {
                if (this.extended) {
                    return 5;
                } else {
                    return 3;
                }
            }
        },
        methods: {
            refreshPriceSummarySticky() {

                if ( ! this.$.isMounted ){
                    return;
                }

                let stickyOptions = {
                    bottom: '! .cart-content-wrapper',
                    top: 150,
                    offset: 150
                };


                this.$s.ui.adapter.sticky(this.$refs.priceSummarySticky, stickyOptions);
            },
            getLocalProductById (id) {
                let result = {};
                this.products.forEach((product) => {
                    if (product.id === id) {
                        result = product;
                        return false;
                    }
                });

                return result;
            },
            toggleMonthlyPrice() {
                this.expandedImmediatePrice = ! this.expandedImmediatePrice
                this.refreshPriceSummarySticky();
            },
            toggleImmediatePrice() {
                this.expandedMonthlyPrice = ! this.expandedMonthlyPrice;
                this.refreshPriceSummarySticky();
            }

        },
        watch : {

        },

        created () {

            },
        mounted () {
            this.refreshPriceSummarySticky();
        }
    }
</script>

<style scoped lang="scss">


    .cart-content {


        .extended & {
            max-height: none;
        }
    }

    .cart-empty {
        color: var(--global-primary-background);
        text-align: center;
        display: flex;
        height: 100%;
        width: 100%;
        justify-content: center;

        > * {
            color: var(--global-primary-background);
            text-align: center;
        }
    }

    .cart-title {
        position: relative;
        padding-top: calc(var(--global-small-gutter)*0.2);
        padding-right: calc(var(--global-small-gutter)*0.8);
        padding-bottom:calc(var(--global-small-gutter)*0.6);
        padding-left: calc(var(--global-small-gutter)*0.8);
    }

    .cart-title-text {
        position: relative;
        top: 3px;
        font-size:var(--text-large-font-size);
    }

    .uk-offcanvas .cart-proceed-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;

        .uk-button {
            &:hover {
                background-color: var(--global-background)!important;
                color: var(--global-primary-background)!important;
            }
        }

    }

    .cart-header-final-price {
        color: var(--global-primary-background)!important;
        font-size: calc(var(--global-font-size)*1.1);
        font-weight: 500;
    }

    .cart-header-summery {
        padding-top: 4px;
        padding-bottom: 4px;
    }

    .cart-header-final-price{
        margin-right: 2px;
    }

    .cart-main {
        max-height: calc(100% - 130px )
    }

    .entry-price {
        width: 95px;
        flex: 0 0 95px;

        .entry-final-price {
            white-space: nowrap;
            border-radius: var(--border-radius-small);
        }

        .cart-price-separator{
            margin: 5px 0;
            height: 1px;
            width: 100%;
            background: var(--global-muted-color);
        }

        .entry-final-price {
            text-align: center;
            width: 100%;
            padding: calc(var(--global-small-gutter)/4) calc(var(--global-small-gutter)/2);
            background: var(--global-primary-background);
            color: var(--global-background);
            font-weight: 600;
        }

        .entry-old-price {
            text-align: center;
            width: 100%;

        }
    }

    .entry-image {
        border: 2px solid var(--global-muted-background);
        padding: 2px;
        width: 100px;
        flex: 0 0 100px;
    }

    .entry-title{
        font-weight: 600;
    }

    .entry-detail {
        font-size: calc(var(--global-font-size)*0.8);
    }

    .details-wrap {
        .extended & {
            min-width: 170px;
        }
    }

    .details-cta {
        max-width: 400px;
    }


    .type-price-summary {
        height: auto;
        align-self: flex-start;
        padding-top: calc(var(--global-margin) * 1);
        padding-left: calc(var(--global-margin) * 0.75);
        padding-right: calc(var(--global-margin) * 0.75);
        padding-bottom: calc(var(--global-margin) * 1);
   //     border: 1px solid red;

    }

    .type-summary {
        .type-summary-expand-text {
            font-weight: bold;
            cursor: pointer;
            text-decoration: underline;
        }

        .price-col {
            font-size: calc(var(--global-font-size) * 1.2);
            font-weight: 600;
            color: var(--global-primary-background);
        }

        .desc-col {
            .desc-icon {
                transition: transform 200ms ease-out;
            }

            &:hover {
                .desc-icon {
                    transform: rotate(45deg);
                }

            }

            &.active {
                .desc-icon {
                    transform: rotate(90deg);
                }
            }
        }
    }

    .type-details {

        .price-col {
            color: var(--global-primary-background);
        }
    }


    .entry-builder {

    }

    .entry-builder--subscription {
        position: relative;

        .entry-image {
            border: none;
        }

        .uk-button {
            min-width: 120px;
        }

        .entry-detail {
            margin-bottom: calc(var(--global-margin) * 2);
        }

       .plan-block, .phone-block {
           border-radius: var(--border-radius-small);
           border: 1px solid var(--global-muted-background);
           box-shadow: 3px 3px 12px 0 rgba(0,0,0,0.1);
           min-height: 225px;

           .subscription-builder-part-footer {
               margin-top: auto;
           }
       }

        .plan-block {
            margin-inline-end: 4px;
        }

        .phone-block {
            margin-inline-start: 4px;
        }

        .plus {
            position: absolute;
            top: 50%;
            left: 50%;
            padding: calc(var(--global-margin) * 0.4);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;
            transform: translateX(-50%) translateY(-50%);
        }

        .builder-piece-price {
            font-size: calc(var(--global-font-size) * 0.8);

            .first-price {
                font-size: calc(var(--global-font-size) * 0.9);
                color: var(--global-primary-background);
            }

            .later-price-actual-price {
                color: var(--global-primary-background);
            }

        }

        .add-mobile-cta:not(.disabled),
        .add-subscription-cta:not(.disabled) {
            cursor: pointer;
            transition:
                    backround-color 450ms ease,
                    color 450ms ease,
                    box-shadow 450ms ease;

            .cta-text-title {
                transition: backround-color 450ms ease, color 450ms ease;
            }

            &:hover {
                background-color: var(--global-primary-background);
                color: var(--global-inverse-color);
                box-shadow: 0 0 15px 0px rgba(0,0,0,0.2) inset;

                .cta-text-title {
                    color: var(--global-inverse-color);
                }
            }
        }

        .tax-info {
            .rate {

            }
        }
    }
</style>
